import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import CoverPhoto from './CoverPhoto';
import Address from './Address';
import Description from './Description';
// import Offers from './Offers';
import Photos from './Photos';
import Reviews from './Reviews';
import Services from './Services';
import { Link, Element } from 'react-scroll';
import { map, cloneDeep, each, findIndex, isEmpty } from 'lodash';
import PageLoader from '../common/PageLoader';
import LightBox from '../common/LightBox';
import Slider from 'react-slick';
import { imageBasePath } from '../../constants/staticData';
var uniqid = require('uniqid');
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class VendorProfile extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    this.open = this.open.bind(this);
    this.props.actions.clearGarageProfileBatchId();

    this.state = {
      searchMobile: false,
      testCompanyImage: {},
      isLoaded: false,
      notificationVisible: false,
      showSidebar: false,
      showModal: false,
      companyImages: [],
      showSetAsCover: false,
      imageUploaded: [],
      imageStartIndex: 0,
      topFix: false,
      selectedNav: 'overview'
    };
    this.uploadImageError = this.uploadImageError.bind(this);
    this.uploadCompanyImageError = this.uploadCompanyImageError.bind(this);
    this.handleSetActive = this.handleSetActive.bind(this);
  }
  getInitialState() {
    return { showModal: false };
  }
  componentWillMount() {
    // this.props.actions.createGarageProfileBatchId();
    window.addEventListener('scroll', this.scrollPage.bind(this));
    this.props.actions.hideToastMessage();
    let garage_id = JSON.parse(localStorage.getItem('garage_id'));
    if (garage_id) {
      this.props.actions.getGarageProfile(garage_id);
      this.props.actions.getGarageCategoryPrices(garage_id);
    }

    this.props.actions.getAllServices(false);
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    if (authData.garageId) {
      this.props.actions.getRatingsAndReviews(authData.garageId, 0, 10, 'rating=-1', false);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorProfileReducer.isVendorProfileLoaded) {
      this.setState({ isLoaded: nextProps.vendorProfileReducer.isVendorProfileLoaded });
    }
    if (
      !isEmpty(nextProps.vendorProfileReducer.newGarageProfileData.images) &&
      nextProps.vendorProfileReducer.newGarageProfileData.images.length
    ) {
      let companyImages = cloneDeep(nextProps.vendorProfileReducer.newGarageProfileData.images);
      let showSetAsCover = this._imageGallery
        ? nextProps.vendorProfileReducer.newGarageProfileData.images[this._imageGallery.getCurrentIndex()]
            ? nextProps.vendorProfileReducer.newGarageProfileData.images[this._imageGallery.getCurrentIndex()].isCover
                ? false
                : true
            : nextProps.vendorProfileReducer.newGarageProfileData.images[this._imageGallery.getCurrentIndex() - 1]
                ? false
                : true
        : false;
      this.setState({
        showSetAsCover: showSetAsCover,
        companyImages: companyImages
      });
    } else {
      this.setState({
        showModal: false,
        showSetAsCover: false,
        companyImages: nextProps.vendorProfileReducer.newGarageProfileData.images
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollPage.bind(this));
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  close() {
    this.setState({ showModal: false });
  }

  open(selectedIndex) {
    if (this.state.companyImages.length) {
      let companyImages = cloneDeep(this.props.vendorProfileReducer.newGarageProfileData.images);
      if (selectedIndex == false && selectedIndex != 0) {
        let coverImageIndex = findIndex(companyImages, { isCover: true });
        selectedIndex = coverImageIndex;
      }
      if (selectedIndex && this._imageGallery) {
        this._imageGallery.slideToIndex(selectedIndex);
      }
      this.setState({
        companyImages: companyImages,
        showSetAsCover: selectedIndex
          ? companyImages[selectedIndex].isCover ? false : true
          : companyImages[0].isCover ? false : true,
        showModal: true,
        imageStartIndex: selectedIndex ? selectedIndex : 0
      });
    } else {
      this.setState({
        showSetAsCover: false,
        showModal: false
      });
    }
  }

  changeCoverImage(image) {
    // e.preventDefault();
    if (image.id) {
      this.props.actions.changeBusinessCoverImage(image.id);
    }
  }
  uploadImageError(value) {
    this.props.actions.addGarageProfilePictureTest(
      value,
      this.props.vendorProfileReducer.newGarageProfileData.batch_id,
      '',
      false
    );
  }
  uploadCompanyImageError(value) {
    this.props.actions.updateGarageLogo(value, false, true);
  }
  fileNameUpload(e) {
    let files = [], fileImgSizeError = false, errFileType = false, fileBlob = [];
    // this.setState({ uploadImageErrText: false });
    each(e.target.files, val => {
      files.push({ name: val.name, path: URL.createObjectURL(val), size: val.size });
      val.localUniqueId = uniqid();
      fileBlob.push(val);
      if (val.size > 25000000) {
        fileImgSizeError = true;
      }
      if (val.type == 'image/png' || val.type == 'image/jpeg') {
      } else {
        errFileType = true;
      }
    });
    if (this.state.companyImages.length + files.length > 5) {
      files = [];
      fileBlob = [];
      this.props.actions.showToastMessage('Maximum allowed limit is 5.', 'error');
    } else {
      // this.props.actions.addGarageProfilePicture(fileBlob, this.props.vendorProfileReducer.newGarageProfileData.batch_id);
      let selectedImages = [...this.state.companyImages];
      let that = this;
      if (errFileType || fileImgSizeError) {
        this.props.actions.showToastMessage(
          'Sorry, the file size should not be above 25MB and should be in JPG or PNG format.',
          'error'
        );
      } else {
        map(fileBlob, value => {
          let img = new Image();
          img.onload = function() {
            value.height = this.height;
            value.width = this.width;
            that.props.actions.getSignedURL(
              value,
              'vendor',
              that.props.vendorProfileReducer.newGarageProfileData.batch_id,
              data => {
                if (data) {
                  that.props.actions.uploadImage(
                    value,
                    data.signed_request,
                    data.url,
                    data.imageId,
                    true,
                    imageId => {
                      // let newImagesArray = cloneDeep(this.state.newImagesArray);
                      // newImagesArray.push(imageId);
                      // this.setState({ newImagesArray: newImagesArray });
                      that.props.actions.addGarageProfilePictureTest(
                        value,
                        that.props.vendorProfileReducer.newGarageProfileData.batch_id,
                        imageId,
                        true
                      );

                      if (
                        that.props.vendorProfileReducer.newGarageProfileData.images &&
                        that.props.vendorProfileReducer.newGarageProfileData.images.length &&
                        that.props.vendorProfileReducer.newGarageProfileData.images[0] &&
                        that.props.vendorProfileReducer.newGarageProfileData.images[0].id == data.imageId &&
                        that.props.vendorProfileReducer.garageProfileDetails &&
                        that.props.vendorProfileReducer.garageProfileDetails.id
                      ) {
                        that.props.actions.changeBusinessCoverImage(data.imageId);
                      }
                    },
                    () => that.uploadImageError(value)
                  );
                }
              },
              () => that.uploadImageError(value),
              that.props.vendorProfileReducer.garageProfileDetails &&
                that.props.vendorProfileReducer.garageProfileDetails.id
            );
          };
          selectedImages.push({
            isUploaded: false,
            isFailed: false,
            thumbnail: URL.createObjectURL(value),
            original: URL.createObjectURL(value),
            localUniqueId: value.localUniqueId,
            isCover: false
          });

          img.onerror = function() {
            // alert( "not a valid file: " + value.type);
          };
          img.src = URL.createObjectURL(value);
        });
      }
      this.setState({ companyImages: selectedImages });
    }
    e.target.value = null;
  }

  companyLogoUpload(e) {
    let files = [], fileImgSize = 0, errFileType = false, fileBlob = [];
    each(e.target.files, val => {
      files.push({ name: val.name, path: URL.createObjectURL(val), size: val.size });
      fileBlob = val;
      fileImgSize = val.size;
      if (val.type == 'image/png' || val.type == 'image/jpeg') {
      } else {
        errFileType = true;
      }
    });
    this.setState({ testCompanyImage: { original: files.length && files[0].path } });
    let width = 0;
    let height = 0;
    // let that = this;
    setTimeout(
      () => {
        let img = document.getElementById('vp-company-logo');
        // img.onload = function () {
        width = img.naturalWidth;
        height = img.naturalHeight;
        // }
        img.src = '';
        if (fileImgSize >= 1000000 || errFileType == true || files.length > 1 || width > 250 || height > 250) {
          let errorMessage = files.length > 1
            ? 'Maximum image limit for logo is one.'
            : 'Sorry, the file size should not be above 1MB and should be in JPG or PNG format. Dimension should be less than 250px X 250px';
          // errorMessage = (width != 250 || height != 250) ? 'The allowed dimension in 250px X 250px' : errorMessage;
          this.props.actions.showToastMessage(errorMessage, 'error');
        } else {
          let that = this;

          let img = new Image();
          img.onload = function() {
            fileBlob.height = this.height;
            fileBlob.width = this.width;

            that.props.actions.getSignedURL(
              fileBlob,
              'logo',
              false,
              data => {
                if (data) {
                  that.props.actions.uploadImage(
                    fileBlob,
                    data.signed_request,
                    data.url,
                    data.imageId,
                    false,
                    imageId => {
                      // that.props.actions.updateGarageLogo(data.url, true, true);
                      that.props.actions.changeCompanyLogo(data.url, true);
                    },
                    () => that.uploadImageError(fileBlob)
                  );
                }
              },
              () => that.uploadImageError(fileBlob),
              false
            );
          };

          img.onerror = function() {
            // alert( "not a valid file: " + value.type);
          };
          img.src = URL.createObjectURL(fileBlob);
        }
      },
      500
    );
    e.target.value = null;
  }

  cancelImageUpload(val, image) {
    this.props.actions.removeGarageImage(image.id, this.state.companyImages);
  }

  // scrollPage() {
  //   if (document.getElementsByClassName('vendor-description')[2] && window.pageYOffset > document.getElementsByClassName('vendor-description')[2].offsetHeight - 150) {
  //     this.setState({ topFix: true });
  //   } else if (this.state.topFix){
  //     this.setState({ topFix: false });
  //   }
  // }
  scrollPage() {
    if (
      document.getElementsByClassName('vendor-base-header') &&
      document.getElementsByClassName('vendor-base-header').length &&
      window.pageYOffset > document.getElementsByClassName('vendor-base-header')[0].offsetHeight + 370
    ) {
      this.setState({ topFix: true });
    } else if (this.state.topFix) {
      this.setState({ topFix: false });
    }
  }
  handleSetActive(to) {
    if (to === 't-overview' || to === 'overview') {
      this.setState({ selectedNav: 'overview' });
    } else if (to === 't-services' || to === 'services') {
      this.setState({ selectedNav: 'services' });
    } else if (to === 't-reviews' || to === 'reviews') {
      this.setState({ selectedNav: 'reviews' });
    }
  }
  render() {
    const { vendorProfileReducer, commonReducer, actions, router } = this.props;
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      responsive: [
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    };
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={commonReducer}
          actions={actions}
          notificationCount={2}
          profileName="Derrick Frank"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={router}
        />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {this.state.isLoaded
            ? <div className="container-fluid main-container vpadLR0">
                <div className="col-md-12 vpadLR0">
                  <div className="overview-heading mobile-overview-heading">
                    <h5>Company Profile</h5>
                  </div>
                  <img
                    id={'vp-company-logo'}
                    style={{ position: 'absolute', visibility: 'hidden', height: '0px', width: '0px' }}
                    src={this.state.testCompanyImage.original ? this.state.testCompanyImage.original : ''}
                  />
                  <CoverPhoto
                    testCompanyImage={this.state.testCompanyImage}
                    pickImages={this.fileNameUpload.bind(this)}
                    uploadCompanyLogo={this.companyLogoUpload.bind(this)}
                    companyImages={this.state.companyImages}
                    openModal={index => {
                      this.open(index);
                    }}
                    garageProfileDetails={vendorProfileReducer.garageProfileDetails}
                  />
                  <div className={this.state.topFix ? 'vendor-base-header active' : 'vendor-base-header'}>
                    <div className="fixed-header-profile">
                      <span className="fixed-header-profile-pic">
                        <img
                          src={
                            vendorProfileReducer.garageProfileDetails.logo
                              ? vendorProfileReducer.garageProfileDetails.logo
                              : `${imageBasePath}/placeholder.png`
                          }
                          alt=""
                        />
                      </span>
                      <h4>{vendorProfileReducer.garageProfileDetails.companyprofilename}</h4>
                    </div>
                    <ul className="bh_desk-view">
                      <li className={this.state.selectedNav == 'overview' ? 'active' : ''}>
                        <Link
                          to="t-overview"
                          spy={true}
                          smooth={true}
                          offset={this.state.topFix ? -150 : 0}
                          onSetActive={this.handleSetActive}
                        >
                          Overview
                        </Link>
                      </li>
                      <li className={this.state.selectedNav == 'services' ? 'active' : ''}>
                        <Link
                          to="t-services"
                          spy={true}
                          smooth={true}
                          offset={this.state.topFix ? -150 : 0}
                          onSetActive={this.handleSetActive}
                        >
                          Services
                        </Link>
                      </li>
                      <li className={this.state.selectedNav == 'reviews' ? 'active' : ''}>
                        <Link
                          to="t-reviews"
                          spy={true}
                          smooth={true}
                          offset={this.state.topFix ? -150 : 0}
                          onSetActive={this.handleSetActive}
                        >
                          {' '}Reviews
                        </Link>
                      </li>

                    </ul>
                    <ul className="bh_mobile-view">
                      <Slider {...settings}>
                        <li className={this.state.selectedNav == 'overview' ? 'active' : ''}>
                          <Link
                            to="overview"
                            spy={true}
                            smooth={true}
                            offset={this.state.topFix ? -150 : 0}
                            onSetActive={this.handleSetActive}
                          >
                            Overview
                          </Link>
                        </li>
                        <li className={this.state.selectedNav == 'services' ? 'active' : ''}>
                          <Link
                            to="services"
                            spy={true}
                            smooth={true}
                            offset={this.state.topFix ? -150 : 0}
                            onSetActive={this.handleSetActive}
                          >
                            Services
                          </Link>
                        </li>
                        <li className={this.state.selectedNav == 'reviews' ? 'active' : ''}>
                          <Link
                            to="reviews"
                            spy={true}
                            smooth={true}
                            offset={this.state.topFix ? -150 : 0}
                            onSetActive={this.handleSetActive}
                          >
                            {' '}Reviews
                          </Link>
                        </li>
                      </Slider>
                    </ul>
                  </div>
                  <div
                    className={this.state.topFix ? 'vendor-profile-section row active' : 'vendor-profile-section row'}
                  >
                    <div className="vp-desk-view">
                      <div className="col-md-8 col-xs-12 vp_left vpadLR0">
                        <Element name="t-overview">
                          <Description garageProfileDetails={vendorProfileReducer.garageProfileDetails} />
                        </Element>
                        <Element name="t-services">
                          <Services
                            vendorProfileReducer={vendorProfileReducer}
                            garageServices={vendorProfileReducer.garageProfileDetails.garage_services}
                            garageManufacturers={vendorProfileReducer.garageProfileDetails.garage_mfrs}
                          />
                        </Element>
                        <Element name="t-reviews">
                          <Reviews actions={actions} vendorProfileReducer={vendorProfileReducer} />
                        </Element>
                      </div>
                      <div className="col-md-4 col-xs-12 vp_right vpadLR0">
                        <Photos
                          openModal={index => {
                            this.open(index);
                          }}
                          companyImages={this.state.companyImages}
                        />
                        <Address garageProfileDetails={vendorProfileReducer.garageProfileDetails} />
                        {/* <Element name="t-offers">
                          <Offers />
                        </Element> */}
                      </div>
                    </div>
                    <div className="vp-mobile-view">
                      <Element name="overview">
                        <Description isMobile={true} garageProfileDetails={vendorProfileReducer.garageProfileDetails} />
                      </Element>
                      <Element name="services">
                        <Services
                          isMobile={true}
                          vendorProfileReducer={vendorProfileReducer}
                          garageServices={vendorProfileReducer.garageProfileDetails.garage_services}
                          garageManufacturers={vendorProfileReducer.garageProfileDetails.garage_mfrs}
                        />
                      </Element>
                      <Photos
                        openModal={index => {
                          this.open(index);
                        }}
                        companyImages={this.state.companyImages}
                      />
                      <Address garageProfileDetails={vendorProfileReducer.garageProfileDetails} />
                      {/* <Element name="offers">
                        <Offers isMobile={true} />
                      </Element> */}
                      <Element name="reviews">
                        <Reviews actions={actions} isMobile={true} vendorProfileReducer={vendorProfileReducer} />
                      </Element>
                    </div>
                  </div>
                </div>
              </div>
            : <PageLoader />}
        </div>

        {this.state.companyImages && this.state.companyImages.length
          ? <LightBox
              showUploadIcon={this.state.companyImages.length < 5}
              showSetAsCover={true}
              actions={this.props.actions}
              images={this.state.companyImages}
              imageStartIndex={this.state.imageStartIndex}
              showModal={this.state.showModal}
              isEditable={true}
              closeModal={this.close.bind(this)}
              fileUpload={this.fileNameUpload.bind(this)}
              setAsCover={this.changeCoverImage.bind(this)}
              deleteImage={this.cancelImageUpload.bind(this)}
            />
          : ''}
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendorProfile/VendorProfile.jsx